module.exports = __webpack_public_path__ + "img/BLCA_Endothelial.64bf4e54.png";